const base = `${process.env.REACT_APP_BACKEND_URL}`;
const endpoints = {
  get_all_joinrequests: `${base}/joinrequests/getAllJoinRequests`,
  update_request_status: `${base}/joinrequests/updateRequestStatus`,
};

export default endpoints;
